<template>
  <detail-layout>
    <template slot="header">
      <base-header
        icon="user"
        :content="header"
      />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <Dialog
          :title="$t('certificates.upload_certificate')"
          :visible.sync="showModal"
          width="50%"
          custom-class="min-width-dialog"
          center>
          <span :key="t"  v-for="t in processMessage" class="text-center w-full inline-block word-break-n">{{ t }}</span>
          <template slot="footer" >
            <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2">
              <base-button class="w-full" @click="showModal = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
              <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.apply')" @click="save" :loading="loading" />
            </div>
          </template>
        </Dialog>
        <Dialog
          :title="$t('certificates.check_data')"
          :visible.sync="showModalCheckData"
          width="40%"
          custom-class="min-width-dialog"
          center>
          <span :key="t"  v-for="t in processMessageCheckData" class=" w-full inline-block word-break-n">{{ t }}</span>
          <template slot="footer" >
            <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2">
              <base-button class="w-full" @click="showModalCheckData = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
              <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="subirCertificado" :loading="loading" />
            </div>
          </template>
        </Dialog>
        <el-form
          :model="form"
          :rules="rules"
          ref="ruleForm"
          class="flex flex-row w-full"
        >
          <div class="flex-1">

            <div class="lg:mb-2">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('certificates.type_extend')}}</label>
              <el-form-item prop="type">
                <base-el-select :options="tiposCertificado" class="w-full" v-model="form.type" :disabled="!isCreate" @change="onChangeType" />
              </el-form-item>
            </div>

            <div v-if="(role === 7 || role === 8 || role === 3)">
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="isCreate"/>{{$t('clients.entity_name')}}</label>
              <div class="flex justify-between">
                <el-form-item prop="clienteId" class="w-full">
                  <base-el-select class="w-full" :options="clientes" v-model="form.clienteId" filterable :loading="isGeneralLoading" :disabled="!isCreate" />
                </el-form-item>
                <base-button v-if="!isCreate" class="mb-1 ml-4" mode="primary" :text="$t('app.detail')" @click.prevent.stop="goDetailClient" :loading="isGeneralLoading"/>
              </div>
            </div>

            <div v-if="isCreate && form.type === 'pfx'" >
              <div class="lg:mb-2">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="isCreate"/>{{$t('users.password')}}</label>
                <el-form-item prop="password">
                  <el-input
                    clearable
                    show-password
                    autocomplete="new-password"
                    v-model="form.password"
                    maxlength='255'
                  />
                </el-form-item>
                <div class="flex -mx-2 flex-col lg:flex-row">
                  <div class="px-2  mb-2 lg:mb-0">
                    <base-obligatory-icon v-if="isCreate"/>
                    <el-form-item prop="file" ref="uploadpfxref">
                      <Upload
                        ref="upload"
                        accept=".pfx"
                        id="pfxselector"
                        class="bg-white dark:bg-darkblue-900 dark:bg-darkblue "
                        :class="[isLower1024 ? 'custom-upload-cert' : 'custom-upload ']"
                        drag
                        action="#"
                        :show-file-list="false"
                        :multiple="false"
                        :auto-upload=false
                        :on-remove="handleRemove"
                        :on-change="handleChange">
                        <i class="el-icon-upload"></i>
                        <p v-if="file.name" class="el-upload__text"><em>{{file.name}}</em></p>
                        <div v-else class="el-upload__text" v-html="$tc('app.upload_default_no_file_text', 1)"></div>
                      </Upload>
                    </el-form-item>
                  </div>
                </div>
              </div>
            </div>

            <div class="lg:mb-2" v-if="isCreate && form.type === 'srl'">
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="isCreate"/>{{$t('app.serial_number')}}</label>
              <el-form-item prop="SerialNumber">
                <el-input
                  clearable
                  v-model="form.SerialNumber"
                  maxlength='100'
                />
              </el-form-item>
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="isCreate"/>{{$t('app.name')}}</label>
              <el-form-item prop="CommonName">
                <el-input
                  clearable
                  v-model="form.CommonName"
                  maxlength='50'
                />
              </el-form-item>
            </div>

            <div class="lg:mb-2" v-if="isCreate && form.type === 'usr'">
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="isCreate"/>{{$t('users.entity_name')}}</label>
              <el-form-item prop="user">
                <el-input
                  clearable
                  v-model="form.user"
                  maxlength='50'
                />
              </el-form-item>
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="isCreate"/>{{$t('users.password')}}</label>
              <el-form-item prop="pass">
                <el-input
                  clearable
                  show-password
                  v-model="form.pass"
                  maxlength='50'
                />
              </el-form-item>
            </div>

            <div class="lg:mb-2" v-if="isCreate && (form.type === 'srl' || form.type === 'usr')">
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="isCreate"/>{{$t('certificates.expires_at')}}</label>
              <el-form-item prop="FechaCaducidad">
                <el-date-picker class="bg-white dark:bg-darkblue-900 dark:bg-darkblue"
                  v-model="form.FechaCaducidad" type="date" :picker-options="dateRangeOptions"
                  :format="datePattern" value-format="yyyy-MM-dd[T00:00:00]" placeholder="">
                </el-date-picker>
              </el-form-item>
            </div>

            <div v-if="!isCreate">
              <div  class="lg:mb-2">
                <base-ro-input :label="$t('app.name')" :data="form.CommonName"/>
              </div>
              <div class="lg:mb-2">
                <base-ro-input :label="$t('app.serial_number')" :data="form.SerialNumber"/>
              </div>
              <div class="lg:mb-2">
                <div class="mandatory">
                  <base-ro-input :label="$t('certificates.expires_at')" :data="form.FechaCaducidad"/>
                </div>
              </div>
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode="secondary" :text="isCreate ? $t('app.cancel') : $t('app.back')" icon="cross" @click="goBack" :loading="isGeneralLoading"/>
          <base-button-responsive 
            v-if="isCreate || isCertificateCreation"
            mode="primary"
            :text="$t('app.save_and_continue')"  
            icon="check"
            @click="submitForm('ruleForm')"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"/>
          <base-button-responsive v-if="!isCreate && !isRoleUserOrConsulta" mode="primary" :text="$t('app.replace')" icon="switchhorizontal" @click="replaceCertificate()" :loading="isGeneralLoading" :disabled="isGeneralLoading"/>
        </template>
      </base-footer>
      <create-asociate-cif-to-certificate-dialog 
        v-if="isCreate"
        :dialogOpen="dialogOpenCreateAsociate" 
        @toggleDialog="toggleDialogCreateAsociate" 
        @applyDialog="applyCreateAsociate" 
        @cleanAll="cleanAll"
        :isCreated="dialogForm.isCreated"
        :IdCIFEmpresa="dialogForm.IdCIFEmpresa"
        :NombreCert="dialogForm.NombreCert"
        :SerialCert="dialogForm.SerialCert"
        :InitialCIF="dialogForm.InitialCIF"
        :InitialNombreCIF="dialogForm.InitialNombreCIF"
        />
    </template>
  </detail-layout>
</template>

<script>
import { i18n } from '@/i18n'

import { Upload, Dialog } from 'element-ui'


import DetailLayout from '@/components/layout/DetailLayout.vue'
import CreateAsociateCifToCertificateDialog from '@/components/CreateAsociateCifToCertificateDialog.vue'
// import PfxGrid from '@/components/PfxGrid.vue'

import { getClients } from '@/services/clients/getClients'
import { uploadPFX } from '@/services/certificates/uploadPFX'
import { getPfxData } from '@/services/certificates/getPfxData'
import { uploadSerial } from '@/services/certificates/uploadSerial'
import { uploadUserPass } from '@/services/certificates/uploadUserPass'
import { getCertificate } from '@/services/certificates/getCertificate'
import { linkCertificate } from '@/services/certificates/linkCertificate'
import { createCompanyAutoFill } from '@/services/companies/createCompanyAutoFill'
import getLocaleDateTimeFormat from '@/services/functions/getLocaleDateTimeFormat'
import { setTransitionAllowed } from '@/services/functions/modeAllowedTransitionHelper'

export default {
  /* eslint-disable camelcase */
  name: 'certificate-detail',
  components: {
    Upload,
    Dialog,
    DetailLayout,
    // DetailLayoutFullWidth,
    CreateAsociateCifToCertificateDialog,
  },
  data: function () {
    return {
      dateRangeOptions: {
        firstDayOfWeek: 1,
      },
      loading: false,
      searchView: false,
      activeName: 'es',
      loadingClientes: false,
      clientes: [],
      header: {
        title: i18n.t('certificates.header_long'),
        icon: 'certificates',
        breadcrumb: {},
        nav: [],
        url: 'certificates'
      },
      file: {
        name: '',
        b64: ''
      },
      selectedCifs: [],
      cifHasCertif: false, // flag para indicar que se va a vincular un certificado a un cif que ya tiene otro certificado
      showModal: false,
      showModalCheckData: false,
      // Comprobación cert
      checkDataSerialNumber: '',
      checkDataCommonName: '',
      checkDataExpirationDate: '',
      dialogOpenCreateAsociate: false,
      form: {
        type: 'pfx',
        CommonName: '',
        SerialNumber: '',
        FechaCaducidad: '',
        file: '',
        password: '',
        clienteId: '',
        user: '',
        pass: '',
        id: 0
      },
      dialogForm: {
        isCreated: true,
        IdCIFEmpresa: -1,
        NombreCert: null,
        SerialCert: null,
        TipoCertificado: '',
        InitialCIF: null,
        InitialNombreCIF: null,
      },
      rules: {
        clienteId: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'change'
          }
        ],
        password: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        SerialNumber: [
          { validator: this.isSerialNumberValid, trigger: 'blur' }
        ],
        CommonName: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        user: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        pass: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        type: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'change'
          }
        ],
        FechaCaducidad: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        file: [
          {
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (!this.file.name) {
                callback(new Error(i18n.t('validation.complete')))
              } else {
                callback()
              }
            }
          },
          {
            message: i18n.t('validation.not_single_valid_extension', { ext: '.pfx' }),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (!this.file.name || this.file.name.length < 5 || this.file.name.substr(this.file.name.length - 4).toUpperCase() !== '.PFX') {
                callback(new Error(i18n.t('validation.not_single_valid_extension', { ext: '.pfx' })))
              } else {
                callback()
              }
            }
          }
        ]
      }
    }
  },
  computed: {
    clientId () {
      return this.$store.getters['auth/clientId']
    },
    datePattern () {
      const formatKey = 'numeric_date'
      const locale = i18n.locale || 'es'
      return getLocaleDateTimeFormat(formatKey, locale)
    },
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isClientFilterActive () {
      return this.$store.getters['certificates/isClientFilterActive']
    },
    isCertificateCreation: function () {
      return !!this.$store.getters['app/isInMode'](4)
    },
    actualFilterNav () {
      return this.$store.getters['app/idClienteFilterVNav']
    },
    isRoleUserOrConsulta: function () {
      return this.role === 1 || this.role === 4
    },
    idEmpresa: function () {
      return parseInt(this.$route.params.idCliente)
    },
    serial: function () {
      return this.$route.params.serial
    },
    tipo: function () {
      return this.$route.params.tipoCertificado
    },
    isCreate: function () {
      return this.idEmpresa === -1 || this.idEmpresa === '-1' || this.serial === -1 || this.serial === '-1' || this.tipo === -1 || this.tipo === '-1'
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading || this.loadingDistribuidores || this.loadingClientes
    },
    processMessage: function () {
      const message = []
      if (this.cifHasCertif) {
        message.push(i18n.t('certificates.override_linked_cif'))
      }
      let nombreCert = ''
      if (this.form.type === 'pfx') nombreCert = this.file.name
      else if (this.form.type === 'srl') nombreCert = i18n.t('certificates.with_serial', { serial: this.form.SerialNumber })
      else if (this.form.type === 'usr') nombreCert = i18n.t('certificates.with_username', { username: this.form.user })
      message.push(i18n.t('certificates.upload_certificate_confirmation', { nombreCert }))

      return message
    },
    processMessageCheckData: function () {
      const message = []
      message.push(i18n.t('certificates.check_data_confirmation'))
      message.push('')
      message.push(`${i18n.t('app.serial_number')}: ${this.checkDataSerialNumber}`)
      message.push(`${i18n.t('app.name')}: ${this.checkDataCommonName}`)
      message.push(`${i18n.t('certificates.expires_at')}: ${i18n.d(this.checkDataExpirationDate, 'numeric_datetime', { date: '-', datetime: ' ' })}`)

      return message
    },
    isAdmin: function () {
      return this.$store.getters['app/isAdmin']
    },
    allCifs: function () {
      return this.$store.getters['app/allCifs']
    },
    links: function () {
      const links = []
      this.allCifs.forEach(row => {
        links.push({ id: row.IdCIFEmpresa, value: row.CIF })
      })

      return links
    },
    empresas: function () {
      return this.$store.getters['app/empresas']
    },
    gettingCifs: function () {
      return this.$store.getters['app/gettingCifs']
    },
    tiposCertificado: function () {
      return this.$store.getters['config/TIPOS_CERT'].filter(x => x.id !== 'usr')
    },
  },
  created: async function () {
    if (this.isCreate) await this.$store.dispatch('app/enterMode', 4)

    const idEmpresa = this.idEmpresa
    const serial = this.serial
    const tipoCert = this.tipo
    const breadcrumbs = []
    if (this.role === 7 || this.role === 8 || this.role === 3) {
      this.loadingClientes = true
      const dataClients = await getClients()
      if (dataClients.blnError === true) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', dataClients))
      }
      this.clientes = dataClients.Clientes.map(x => ({ label: x.Nombre, value: x.idCliente }))
      this.loadingClientes = false
    }

    if (!this.isCreate || !this.isCertificateCreation) {
      await this.downloadData(idEmpresa, serial, tipoCert)
      if (this.$route.params.noticeType !== undefined && this.$route.params.noticeType !== null && this.$route.params.noticeType !== '') {
        if (this.$route.params.noticeType === 'certificadoscaducar') {
          this.header.url = 'notices/certificadoscaducar'
          breadcrumbs.push({ path: 'notices/certificadoscaducar', name: i18n.t('avisos.noticesCertsCaduc') })
        } else {
          this.header.url = 'notices/certificadoscaducados'
          breadcrumbs.push({ path: 'notices/certificadoscaducados', name: i18n.t('avisos.noticesCertsCaducados') })
        }
      } else {
        breadcrumbs.push({ path: 'certificates', name: i18n.t('certificates.header') })
      }
      this.form.name = serial
      breadcrumbs.push({ path: '', name: this.form.CommonName })
      this.$store.commit('app/setheaderBreadCrumb', this.form.CommonName)
    } else {
      if (this.actualFilterNav && this.isClientFilterActive) {
        this.form.clienteId = this.actualFilterNav.idCliente 
      }
      breadcrumbs.push({ path: '', name: i18n.t('certificates.new_certificate') })
    }
    this.header.breadcrumb = breadcrumbs
  },
  methods: {
    toggleDialogCreateAsociate () {
      this.dialogOpenCreateAsociate = !this.dialogOpenCreateAsociate
    },
    applyCreateAsociate: async function (data) {
      this.toggleDialogCreateAsociate()
      let idEmpresa
      if (this.role === 7 || this.role === 8 || this.role === 3) {
        idEmpresa = this.form.clienteId
      } else {
        idEmpresa = this.$route.params.idCliente
      }
      if (data.isCreated) {
        const payload = {
          idCIFS: [data.IdCIFEmpresa],
          SerialNumber: this.checkDataSerialNumber,
          TipoCertificado: 'pfx',
          idCliente: idEmpresa
        }
        // Vincular
        this.linkCertificate(payload)
      } else {
        // Crear y vincular
        const payloadCreate = {
          CIF: data.CIF,
          RazonSocial: data.NombreCIF,
          idCliente: idEmpresa
        }
        const responseCreate = await createCompanyAutoFill(payloadCreate)
        if (responseCreate.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', responseCreate))
        } else {
          const payloadLink = {
            idCIFS: [responseCreate.IdCIFEmpresa],
            SerialNumber: this.checkDataSerialNumber,
            TipoCertificado: 'pfx',
            idCliente: idEmpresa
          }
          this.linkCertificate(payloadLink)
        }
      }
      this.cleanAll()
    },
    linkCertificate: async function (data) {
      try {
        this.$store.commit('setIsLoading', true)
        const response = await linkCertificate(data)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.certificate_linked_msg'), 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    createCompanyAutoFill: async function (data) {
      let response = {
        blnError: true,
      }
      try {
        this.$store.commit('setIsLoading', true)
        response = await createCompanyAutoFill(data)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return response
    },
    isSerialNumberValid: function (rule, value, callback) {
      const re = /["<>|:*?\\/]/
      const minLen = 5
      if (!value) {
        return callback(new Error(i18n.t('validation.complete')))
      } else if (re.test(value)) {
        return callback(new Error(i18n.t('validation.codigo_ext.chars')))
      } else if (value.length < minLen) {
        return callback(new Error(i18n.t('validation.length_min') + i18n.tc('app.n_character', minLen)))
      } else {
        callback()
      }
    },
    replaceCertificate () {
      this.$router.push({ 
        name: 'certificates/replace',
        params: { 
          idCliente: this.idEmpresa, 
          serial: this.serial,
          tipoCertificado: this.tipo,
          name: this.form.CommonName, 
          noticeType: this.$route.params.noticeType
        } 
      })
    },
    onChangeType: function (value) {
    },
    toggleSearchView: function () {
      this.searchView = !this.searchView
    },
    submitForm: function (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.cifHasCertif = false
          if (this.form.type === 'pfx') this.uploadPFX()
          else this.showModal = true
        } else {
          this.$message({ type: 'error', message: i18n.t('feedback.error.process_data_error') })
          return false
        }
      })
    },
    goBack: function () {
      this.$router.push({ name: 'certificates' })
    },
    goDetailClient () {
      const id = this.idEmpresa
      this.$router.push({ name: 'configurations/clients/details', params: { id } })
    },
    goNext (params) {
      setTransitionAllowed(4, true)
      this.$router.push({ name: 'certificates/companies', params: params })
    },
    downloadData: async function (idEmpresa, serial, tipoCertificado) {
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idCliente: idEmpresa,
          serial,
          tipoCertificado
        }
        const data = await getCertificate(params)
        if (data.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', data))
        } else {
          this.setCertificate(data.Certificado)
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    setCertificate: function (certificate) {
      this.form.SerialNumber = certificate.SerialNumber
      this.form.type = certificate.TipoCertificado
      this.form.CommonName = certificate.CommonName
      this.form.FechaCaducidad = i18n.d(certificate.FechaCaducidad, 'numeric_datetime', { date: '-', datetime: ' ' })
      this.form.clienteId = certificate.idCliente
    },
    handleChange: function (file) {
      this.$refs.uploadpfxref.clearValidate()
      this.file.name = file.name
      this.getBase64(file.raw).then(res => {
        const b64 = res.split(',')
        this.file.b64 = b64[1]
      })
    },
    handleRemove: function () {
      this.file.name = null
      this.file.b64 = null
    },
    getEmpresas: function () {
      this.$store.dispatch('app/getEmpresas')
    },
    getBase64 (file) {
      return new Promise(function (resolve, reject) {
        const reader = new FileReader()
        let res = ''
        reader.readAsDataURL(file)
        reader.onload = function () {
          res = reader.result
        }
        reader.onerror = function (error) {
          reject(error)
        }
        reader.onloadend = function () {
          resolve(res)
        }
      })
    },
    save: async function () {
      try {
        this.loading = true
        await this.uploadPFX()
        this.showModal = false
      } catch (error) {
        this.doFeedback()
      } finally {
        this.loading = false
      }
    },
    uploadPFX: async function () {
      let idEmpresa
      if (this.role === 7 || this.role === 8 || this.role === 3) {
        idEmpresa = this.form.clienteId
      } else {
        idEmpresa = this.$route.params.idCliente
      }

      if (this.form.type === 'pfx') {
        const payload = {
          Base64PFX: this.file.b64,
          PasswordPFX: this.form.password,
          idCliente: idEmpresa,
        }
        const responseGetData = await getPfxData(payload)
        if (responseGetData.blnError === false) {
          this.checkDataSerialNumber = responseGetData.datosCertificado.SerialNumber
          this.checkDataCommonName = responseGetData.datosCertificado.CommonName 
          this.checkDataExpirationDate = responseGetData.datosCertificado.ExpirationDate
          this.showModalCheckData = true
        } else {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', responseGetData))
        }
      } else {
        this.subirCertificado()
      }
    },
    subirCertificado: async function () {
      this.showModalCheckData = false
      this.$store.commit('app/setLoading', true)
      let idEmpresa
      if (this.role === 7 || this.role === 8 || this.role === 3) {
        idEmpresa = this.form.clienteId
      } else {
        idEmpresa = this.$route.params.idCliente
      }

      let response = null
      if (this.form.type === 'pfx') {
        response = await uploadPFX(this.file.b64, this.form.password, idEmpresa)
      } else if (this.form.type === 'srl') {
        response = await uploadSerial({
          SerialNumber: this.form.SerialNumber,
          CommonName: this.form.CommonName,
          FechaCaducidad: this.form.FechaCaducidad,
          idCliente: idEmpresa
        })
      } else if (this.form.type === 'usr') {
        response = await uploadUserPass({
          Usuario: this.form.user,
          Password: this.form.pass,
          FechaCaducidad: this.form.FechaCaducidad,
          idCliente: idEmpresa
        })
      }

      if (response.blnError === false) {
        this.doFeedback(i18n.t('feedback.success.certificate_uploaded_msg'), 'success')
        // if (this.form.type === 'pfx' && !this.isRoleUserOrConsulta) {
        //   // Setear y abrir dialogo
        //   this.dialogForm.isCreated = response.existeCIF
        //   this.dialogForm.IdCIFEmpresa = response.datosCertificadoCIF.idCIFEmpresa
        //   this.dialogForm.InitialCIF = response.datosCertificadoCIF.CIF
        //   this.dialogForm.InitialNombreCIF = response.datosCertificadoCIF.RazonSocial
        //   if (response.datosCertificadoCIF.datosCertificadoVinculado) {
        //     this.dialogForm.NombreCert = response.datosCertificadoCIF.datosCertificadoVinculado.CommonName
        //     this.dialogForm.SerialCert = response.datosCertificadoCIF.datosCertificadoVinculado.SerialNumber
        //   }
        //   this.toggleDialogCreateAsociate()
        // } else {
        this.$store.commit('app/setLoading', false)
        const params = {
          idCliente: (this.role === 7 || this.role === 8 || this.role === 3) ? this.form.clienteId : this.clientId,
          serial: this.form.type === 'pfx' ? this.checkDataSerialNumber : this.form.SerialNumber,
          tipoCertificado: this.form.type
        }
        this.cleanAll()
        if (this.isCertificateCreation) this.goNext(params)
        // }
      } else {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
      }
      
      this.$store.commit('app/setLoading', false)
    },
    cleanAll () {
      if (this.form.type === 'pfx') this.$refs.upload.clearFiles()
      this.file = {
        name: null,
        b64: null
      }
      this.resetForm()
      const tmpType = this.form.type
      this.form = {
        type: tmpType,
        CommonName: '',
        SerialNumber: '',
        FechaCaducidad: '',
        file: '',
        password: '',
        clienteId: null,
        user: '',
        pass: '',
        id: 0
      }
      this.checkDataSerialNumber = ''
      this.checkDataCommonName = ''
      this.checkDataExpirationDate = ''
    },
    resetForm () {
      this.$refs.ruleForm.resetFields()
    },
    selectionChange: function (selectedData) {
      this.selectedCifs = selectedData
    },
    querySearch: function (queryString, cb) {
      const links = this.links
      const results = queryString ? links.filter(this.createFilter(queryString)) : links
      // call callback function to return suggestions
      cb(results)
    },
    createFilter: function (queryString) {
      return (link) => {
        return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      }
    },
    handleSelect: function (item) {
      this.selectedCifs = []
      this.selectedCifs.push(item)
    }
  }

}
</script>

<style scoped>

.el-upload-dragger {
    background-color: #fff;
    border: 1px
    dashed #d9d9d9;
    border-radius: 6px;
    box-sizing: border-box;
    width: 360px;
    height: 180px;
    text-align: center;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.tip {
  grid-column: 1 / -1;
}
.pic>img {
  max-width: 100%;
  max-height: 100%;
}

.file-selected {
  color: rgb(90, 90, 90);
  text-transform: uppercase;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

 .el-loading-parent--relative {
    position: relative !important; }

  .el-loading-parent--hidden {
    overflow: hidden !important; }

    div.el-loading-mask {
        background-color: rgba(6,13,46,.8);
    }

  .el-loading-mask {
    position: absolute;
    z-index: 2000;
    background-color: rgba(255, 255, 255, 0.9);
    margin: 0;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    -webkit-transition: opacity 0.3s;
    transition: opacity 0.3s; }
    .el-loading-mask.is-fullscreen {
      position: fixed; }
      .el-loading-mask.is-fullscreen .el-loading-spinner {
        margin-top: -25px; }
        .el-loading-mask.is-fullscreen .el-loading-spinner .circular {
          height: 50px;
          width: 50px; }
    div.el-loading-mask .el-loading-spinner {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
}
body.el-loading-parent--relative {
    position: inherit !important;
}
  .el-loading-spinner {
    top: 50%;
    margin-top: -21px;
    width: 100%;
    text-align: center;
    position: absolute; }
    .el-loading-spinner .el-loading-text {
      color: #00BBFF;
      margin: 3px 0;
      font-size: 14px; }
    .el-loading-spinner .circular {
      height: 42px;
      width: 42px;
      -webkit-animation: loading-rotate 2s linear infinite;
      animation: loading-rotate 2s linear infinite; }
    .el-loading-spinner .path {
      -webkit-animation: loading-dash 1.5s ease-in-out infinite;
      animation: loading-dash 1.5s ease-in-out infinite;
      stroke-dasharray: 90, 150;
      stroke-dashoffset: 0;
      stroke-width: 2;
      stroke: #00BBFF;
      stroke-linecap: round; }
    .el-loading-spinner i {
      color: #00BBFF; }

  .el-loading-fade-enter,
  .el-loading-fade-leave-active {
    opacity: 0; }
</style>

<style lang="sass" scoped>
</style>
